import EventEmitter from "./EventEmitter";
import Utils from "./Utils";

export default class Animator extends EventEmitter {
  constructor() {
    super();
    this.lerpTiming = 0.1;
    this.transitionLimit = 50;
    this.AUTOMATED_EXTRA_STEPS = 10;
    this.DEFAULT_SPEED = 75;
    this.allAnimations = [];
  }
  set color(color) {
    this.LINE_COLOR = color;
  }

  reset() {
    this.AUTOMATED_EXTRA_STEPS = 10;
    this.DEFAULT_SPEED = 75;
  }

  setNewSegments(segments) {
    this.drawing_is_done = false;
    this.index = 0;
    this.seg2Lerp = [];
    this.allAnimations = [];
    segments.forEach((seg) => {
      const position = [
        { x: seg.originSegment[0].x, y: seg.originSegment[0].y },
        { x: seg.originSegment[1].x, y: seg.originSegment[1].y },
      ];
      const goal = [
        { x: seg.line[0].x + seg.offset.x, y: seg.line[0].y + seg.offset.y },
        { x: seg.line[1].x + seg.offset.x, y: seg.line[1].y + seg.offset.y },
      ];
      this.seg2Lerp.push([position, goal, seg.index, seg.lineIndex]);
    });
    // console.log(this.index, segments, this.seg3Lerp);s

    this.animation = this.seg2Lerp[this.index];
    if (this.animation) {
      this.raiseEvent("segmentReady", [this.animation[3]]);
      this.allAnimations.push(this.animation);
    }
  }

  update() {
    this.allAnimations.forEach((animation, i) => {
      if (animation) {
        animation[0][0].x = Utils.lerp(
          animation[0][0].x,
          animation[1][0].x,
          this.lerpTiming
        );
        animation[0][0].y = Utils.lerp(
          animation[0][0].y,
          animation[1][0].y,
          this.lerpTiming
        );
        animation[0][1].x = Utils.lerp(
          animation[0][1].x,
          animation[1][1].x,
          this.lerpTiming
        );
        animation[0][1].y = Utils.lerp(
          animation[0][1].y,
          animation[1][1].y,
          this.lerpTiming
        );
        if (
          this.seg2Lerp &&
          this.size(animation, this.transitionLimit) &&
          this.index < this.seg2Lerp.length - 1 &&
          i == this.allAnimations.length - 1
        ) {
          //   this.raiseEvent("segmentReady", [animation[3]]);
          this.index++;
          const newAnimation = this.seg2Lerp[this.index];
          this.allAnimations.push(newAnimation);
          this.raiseEvent("segmentReady", [newAnimation[3]]);
        } else if (
          this.seg2Lerp &&
          this.size(animation, 1) &&
          this.index >= this.seg2Lerp.length - 1 &&
          i == this.allAnimations.length - 1
        ) {
          this.raiseEvent("segmentReady", ["end"]);
          this.raiseEvent("continueDrawing", [
            {
              index: animation[2],
              steps: this.AUTOMATED_EXTRA_STEPS,
              speed: this.DEFAULT_SPEED,
            },
          ]);
          this.animation = null;
          this.seg2Lerp = null;
          this.allAnimations = [];
        }
      }
    });
  }

  //   update() {
  //     if (this.animation) {
  //       this.animation[0][0].x = Utils.lerp(
  //         this.animation[0][0].x,
  //         this.animation[1][0].x,
  //         this.lerpTiming
  //       );
  //       this.animation[0][0].y = Utils.lerp(
  //         this.animation[0][0].y,
  //         this.animation[1][0].y,
  //         this.lerpTiming
  //       );
  //       this.animation[0][1].x = Utils.lerp(
  //         this.animation[0][1].x,
  //         this.animation[1][1].x,
  //         this.lerpTiming
  //       );
  //       this.animation[0][1].y = Utils.lerp(
  //         this.animation[0][1].y,
  //         this.animation[1][1].y,
  //         this.lerpTiming
  //       );
  //       if (this.size(this.animation) && this.index < this.seg2Lerp.length - 1) {
  //         this.raiseEvent("segmentReady", [this.animation[3]]);
  //         this.index++;
  //         this.animation = this.seg2Lerp[this.index];
  //       } else if (this.index >= this.seg2Lerp.length - 1) {
  //         this.raiseEvent("segmentReady", ["end"]);
  //         this.raiseEvent("continueDrawing", [
  //           { index: this.animation[2], steps: 60 },
  //         ]);
  //         this.animation = null;
  //         this.seg2Lerp = null;
  //       }
  //     }
  //   }

  //   continueDrawing(index = 0, steps = 25) {
  //     // From the last line in position, add news lines from the predefined drawing
  //     // The max line is define by @steps param
  //     this.animation = null;
  //     this.scope.drawWithThicknessByStep(this.scope.memory, index, steps);
  //   }

  //   saveLines() {
  //     this.scope.drawSavedSegment(this.scope.memory, this.LINE_COLOR);
  //     this.seg2Lerp = null;
  //   }

  size(lines, limit) {
    const size1 = Utils.dist(
      lines[1][0].x,
      lines[1][0].y,
      lines[1][1].x,
      lines[1][1].y
    );
    const size2 = Utils.dist(
      lines[0][0].x,
      lines[0][0].y,
      lines[0][1].x,
      lines[0][1].y
    );
    if (size1 - size2 < limit) {
      return true;
    }
    return false;
  }
}
